import { renderForm } from 'smartdollar-financial-turnaround-calculator';

window.addEventListener('load', () => {
  const form = document.getElementById(
    'smartdollar-financial-turnaround-calculator-wrapper'
  );

  renderForm(form);
});
